import angular from 'angular'

import { guestRoutes } from './guest.routes'
import { guestRun } from './guest.run'
import { guestService } from './services/guest.service'
import { guestSummaryService } from './services/guest-summary.service'
import { guestResendPasswordService } from './services/guest-resend-password.service'
import { guestHeaderFiltersService } from './services/guest-header-filters.service'
import { guestSummary } from './components/guest-summary/guest-summary.component'
import { guestApprovalStatusCard } from './components/guest-approval-status-card/guest-approval-status-card.component'
import { guestLoginDialog } from './dialogs/guest-login/guest-login-dialog.directive'
import { guestResendPasswordDialog } from './dialogs/guest-resend-password/guest-resend-password-dialog.directive'
import { guestAssetCard } from './components/guest-asset-card/guest-asset-card.component'
import { guestAssetFolder } from './components/guest-asset-folder/guest-asset-folder.component'
import { assetPackService } from './services/asset-pack.service'
import { guestAssetPackDownloadSuccessDialog } from './dialogs/guest-asset-pack-download-success/guest-asset-pack-download-success.directive'

const module = angular
  .module('deskfy.guest', [])
  .config(guestRoutes)
  .run(guestRun)
  .service('AssetPackService', assetPackService) // Makes the service a singleton
  .factory('GuestService', guestService)
  .factory('GuestSummaryService', guestSummaryService)
  .factory('GuestResendPasswordService', guestResendPasswordService)
  .factory('GuestHeaderFiltersService', guestHeaderFiltersService)
  .directive('guestLoginDialog', guestLoginDialog)
  .directive('guestResendPasswordDialog', guestResendPasswordDialog)
  .directive('guestAssetPackDownloadSuccessDialog', guestAssetPackDownloadSuccessDialog)
  .component('guestSummary', guestSummary)
  .component('guestAssetCard', guestAssetCard)
  .component('guestAssetFolder', guestAssetFolder)
  .component('guestApprovalStatusCard', guestApprovalStatusCard)

export const guestModule = module
